import axios from 'axios'
//import axiosQueue from '@/helpers/axios.js'
import store from '@/store'

const validStatuses = [
  200, 201, 202, 203, 204,
  300, 301, 302, 303, 304
]

// Default headers used for every request
function getHeaders (multipart = false) {
  let defaultHeaders = {
    'CONTENT-TYPE': 'application/json',
    'X-REQUESTED-WITH': 'XMLHttpRequest'
  }

  if (multipart) {
    defaultHeaders = {}
  }

  if (localStorage.token) {
    defaultHeaders = {
      'AUTHORIZATION': 'Bearer ' + localStorage.token,
      ...defaultHeaders
    }
  }

  return defaultHeaders
}

// Checking if response was valid or invalid
export function checkResponse (response) {
  if (validStatuses.includes(response.status)) {
    store.dispatch('app/setAppStatus', 'success')
    return Promise.resolve(response)

  // User is not authorized
  } else if (response.status === 401) {
    // !!!FIX!!! Somehow this cannot be used (it breaks the promise chain somehow).. this.$store.dispatch('user/setState', false)
    localStorage.removeItem('token')
    store.dispatch('app/setAppStatus', 'error')
    return Promise.reject(response)

  // Any non-valid response
  } else {
    store.dispatch('app/setAppStatus', 'error')
    return Promise.reject(response)
  }
}

// Encoding data to UTF-8
export const encoder = encodeURIComponent
export function encodeData (params) {
  return (
    Object
      .keys(params)
      .map(k => encoder(k) + '=' + encoder(params[k]))
      .join('&')
  )
}

// Some wrappers to streamline axios usage
export async function post (uri, data, mode) {
  store.dispatch('app/setAppStatus', 'loading')

  if (mode !== 'refreshing') {
    await store.dispatch('user/refresh')
  }

  return axios.post(endpoint(uri), data, {
    headers: getHeaders(),
    withCredentials: true
  }).then(response => {
    return checkResponse(response)
  }).catch(error => {
    return checkResponse(error.response)
  })
}

export async function postHubSpotRegister (data) {
  return axios.post('https://api.hsforms.com/submissions/v3/integration/submit/25601177/77fad273-2d2f-4380-8793-a01dbe89174e', data, {
    'CONTENT-TYPE': 'application/json'
  })
}

export async function put (uri, data) {
  store.dispatch('app/setAppStatus', 'loading')
  await store.dispatch('user/refresh')

  return axios.put(endpoint(uri), data, {
    headers: getHeaders(),
    withCredentials: true
  }).then(response => {
    return checkResponse(response)
  }).catch(error => {
    return checkResponse(error.response)
  })
}

export async function patch (uri, data) {
  store.dispatch('app/setAppStatus', 'loading')
  await store.dispatch('user/refresh')

  return axios.patch(endpoint(uri), data, {
    headers: getHeaders(),
    withCredentials: true
  }).then(response => {
    return checkResponse(response)
  }).catch(error => {
    return checkResponse(error.response)
  })
}

export async function remove (uri) {
  store.dispatch('app/setAppStatus', 'loading')
  await store.dispatch('user/refresh')

  return axios.delete(endpoint(uri), {
    headers: getHeaders(),
    withCredentials: true
  }).then(response => {
    return checkResponse(response)
  }).catch(error => {
    return checkResponse(error.response)
  })
}

export async function get (uri, type = null) {
  store.dispatch('app/setAppStatus', 'loading')
  await store.dispatch('user/refresh')
  let timeout = 10000
  if (type && type === 'news') {
    timeout = 20000
  }

  return axios.get(endpoint(uri), {
    timeout: timeout,
    headers: getHeaders(),
    withCredentials: true
  }).then(response => {
    return checkResponse(response)
  }).catch(error => {
    return checkResponse(error)
  })
}

export async function downloadPost (uri, data) {
  store.dispatch('app/setAppStatus', 'loading')

  return axios.post(endpoint(uri), data, {
    headers: getHeaders(),
    responseType: 'arraybuffer',
    withCredentials: true
  }).then(response => {
    return checkResponse(response)
  }).catch(error => {
    let enc = new TextDecoder('utf-8')
    let arr = error.response.data
    return checkResponse(JSON.parse(enc.decode(arr)))
  })
}

export function endpoint (uri) {
  return process.env.VUE_APP_API_URL + uri
}